module.exports = __webpack_public_path__ + "img/no-data-incoming-outgoing.2b3f7d0f.svg";